import { createRouter, createWebHistory } from "vue-router";
const Home = () => import("../pages/Home.vue");
const SurveyCompleted = () => import("../pages/SurveyCompleted.vue");
const ScreenedOut = () => import("../pages/ScreenedOut.vue");
const QuotaFull = () => import("../pages/QuotaFull.vue");
const NoProject = () => import("../pages/NoProject.vue");
const ErrorPage = () => import("../pages/ErrorPage.vue");
const Evaluate = () => import ("../pages/Evaluate.vue");
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/evaluate",
    name: "Evaluate",
    component: Evaluate,
  },
  {
    path: "/complete",
    name: "Survey Completed",
    component: SurveyCompleted,
  },
  {
    path: "/screened-out",
    name: "Screened Out",
    component: ScreenedOut,
  },
  {
    path: "/quota-full",
    name: "Quota Full",
    component: QuotaFull,
  },
  {
    path: "/no-project",
    name: "No Project",
    component: NoProject,
  },
  {
    path: "/error",
    name: "Error",
    component: ErrorPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
